import image1 from "../../assets/gallery-01_full.jpg";
import image2 from "../../assets/gallery-02_full.jpg";
import image3 from "../../assets/gallery-03_full.jpg";
import image4 from "../../assets/gallery-04_full.jpg";
import image5 from "../../assets/gallery-05_full.jpg";
import image6 from "../../assets/gallery-06_full.jpg";
import image7 from "../../assets/gallery-07_full.jpg";
import image8 from "../../assets/gallery-08_full.jpg";
import image9 from "../../assets/gallery-09_full.jpg";

export const NAVIMAGE = [
  {
    id: 1,
    image: image1,
  },
  {
    id: 2,
    image: image2,
  },
  {
    id: 3,
    image: image3,
  },
  {
    id: 4,
    image: image4,
  },
  {
    id: 5,
    image: image5,
  },
  {
    id: 6,
    image: image6,
  },
  {
    id: 7,
    image: image7,
  },
  {
    id: 8,
    image: image8,
  },
  {
    id: 9,
    image: image9,
  },
];
